import { values } from 'lodash';

import { ConferenceParticipant } from '../../../../../objects/communication/conference-participant/conference-participant';
import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { CommunicationsResponseSchema } from '../../generic/communications-response/communications-response-schema';

import { CommunicationsResponseGetConferenceParticipantsError } from './communications-response-get-conference-participants-error';

export class CommunicationsResponseGetConferenceParticipantsSchema extends CommunicationsResponseSchema {
  public static readonly participants = 'participants';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly type = undefined;

    public static readonly error = undefined;

    public static readonly participants = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[CommunicationsResponseGetConferenceParticipantsSchema.error] = SchemaField.string(
      CommunicationsResponseSchema.Defaults.error,
    )
      .optional()
      .valid(...values(CommunicationsResponseGetConferenceParticipantsError));

    parameters[CommunicationsResponseGetConferenceParticipantsSchema.participants] = SchemaField.arrayOfType(
      SchemaField.obj(ConferenceParticipant, undefined),
      CommunicationsResponseGetConferenceParticipantsSchema.Defaults.participants,
    ).optional();
    /* eslint-enable */

    return parameters;
  }
}
